<template>
  <div>
    <div v-if="show">
      <h2 style="color: #515151">CRIE SUA CONTA E COMECE A ENTREVISTAR</h2>
      <p>VOCÊ ESTÁ A DOIS CLIQUES DE CRIAR SUA PRIMEIRA ENTREVISTA</p>

      <button
        style="background-color: #0076b5 !important"
        class="btn btn-lg full center btn-primary"
        @click="redirectLinkedin"
      >
        <i class="fab fa-linkedin"></i> LINKEDIN
      </button>
      <span style="display: block" class="center mt-2 full">OU</span>
      <div v-if="show">
        <label>EMAIL</label>
        <div class="form-group">
          <input
            class="form-control"
            autofocus
            :class="{
              'is-invalid': $v.user.email.$error,
              'is-valid': !$v.user.email.$invalid,
            }"
            type="email"
            @blur="validateField($v.user.email)"
            v-model="user.email"
            placeholder="EMAIL"
          />
        </div>
      </div>

      <div class="mt-3">
        <div class="mb-4">
          <label for="password">SENHA</label>
          <input
            class="form-control"
            type="password"
            v-model="user.password"
            placeholder="SENHA"
            :class="{ 'is-valid': password_valid }"
          />
          <Password
            v-model="user.password"
            :strength-meter-only="true"
            @score="showScore"
          />
        </div>
      </div>
      <div class="mt-3">
        <div class="mb-4">
          <label for="password">CONFIRMAR SENHA</label>
          <input
            class="form-control"
            type="password"
            v-model="password_confirme"
            placeholder="SENHA"
          />
        </div>
      </div>
      <inputform
        v-model="user.name"
        type="text"
        label="NOME COMPLETO"
        :field="$v.user.name"
      />
      <inputform
        v-model="user.business_name"
        type="text"
        label="NOME DA SUA EMPRESA"
        :field="$v.user.business_name"
      />

      <div class="form-group">
        <label>CELULAR</label>
        <input
          class="form-control"
          type="text"
          v-model="user.mobile_phone"
          v-mask="'+## (##) #####-####'"
          :class="{
            'is-invalid': $v.user.mobile_phone.$error,
            'is-valid': !$v.user.mobile_phone.$invalid,
          }"
        />
      </div>
      <label>
        <input v-model="user.accept_terms" type="checkbox" />ACEITO OS
        <a target="_blank" href="/termos_de_uso">TERMOS DE USO</a>
      </label>
      <label>
        <input v-model="user.accept_marketing" type="checkbox" /> GOSTARIA DE
        RECEBER NOVIDADE POR EMAIL
      </label>
      <button
        :disabled="load"
        @click="submitForm"
        type="button"
        class="btn btn-lg btn-success full mt-3"
      >
        <span v-show="!load">SALVAR</span>
        <div v-show="load" class="spinner-border text-light" role="status">
          <span class="sr-only"></span>
        </div>
      </button>
      <div class="center mt-5">
        <a href="/recruiters/sign_in">JÁ TEM CONTA? {{ showScore() }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Password from "vue-password-strength-meter";
import { required, email } from "vuelidate/lib/validators";
import { providers } from "../../../../../public/providers.json";

export default {
  components: { Password },
  data: () => ({
    show: false,
    teste: "",
    password_confirme: "",
    user: {
      email: "",
      password: null,
      name: "",
      business_name: "",
      mobile_phone: "",
      email: "",
      accept_terms: false,
      accept_marketing: false,
    },
    load: false,
    password_valid: false,
    strength: 0,
    providers: providers,
  }),
  mounted() {
    let self = this;
    setTimeout(() => (this.show = true), 500);
  },
  computed: {
    checkProvider() {
      let user_provider = this.user.email.slice(
        this.user.email.indexOf("@") + 1
      );
      return this.providers.includes(user_provider);
    },
  },
  methods: {
    showScore(score) {
      if (score) this.strength = score;
    },
    validateField(field) {
      field.$touch();
    },
    redirectLinkedin() {
      // if (!this.user.accept_terms) {
      //   this.$toast.error(
      //     "Para continuar vode deve aceitar os termos de uso no final da pagina",
      //     {
      //       position: "top"
      //     }
      //   );
      //   return;
      // }
      window.location = "/recruiters/auth/linkedin";
      // /recruiters/auth/linkedin
    },
    submitForm() {
      if (this.checkProvider) {
        this.$toast.error(
          "Sinto muito, apenas emails corporativos são aceitos"
        );
        return;
      }
      if (this.password_confirme != this.user.password) {
        this.$toast.error("Senha e confirmação de senha estão diferentes", {
          position: "top",
        });
        return;
      }
      if (!this.user.accept_terms) {
        this.$toast.error(
          "Você precisa aceitar os termos de uso para concluir o cadastro",
          { position: "top" }
        );
        return;
      }
      if (!this.valid_form()) {
        this.$toast.error(
          "Email precisa ser válido e a senha precisa ser forte",
          { position: "top" }
        );
        return;
      }

      this.$v.user.$touch();
      if (this.$v.user.$error) {
        this.$toast.error("Preencha corretamente os campos para continuar", {
          position: "top",
        });
        this.load = false;

        return false;
      }

      this.load = true;

      axios
        .post("/recruiters", { recruiter: this.user })
        .then((response) => {
          this.$emit("setEmail", this.user.email);
          eventBus.$emit("stepTwo", true);
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error(
            "Verifique a validade dos seus dados, ou se esse email já tem conta criada",
            { position: "top" }
          );
          this.load = false;
          return;
        });
    },
    valid_form() {
      if (!this.$v.user.email.$invalid && this.strength >= 3) {
        return true;
      }
      return false;
    },
  },
  watch: {
    strength(new_strength) {
      if (new_strength >= 3) {
        this.password_valid = true;
        return;
      }
      this.password_valid = false;
    },
  },
  validations: {
    teste: { required, email },
    user: {
      email: { required, email },
      name: { required },
      business_name: { required },
      mobile_phone: { required },
    },
  },
};
</script>

